import React from "react";
import HistoricalTable from "./HistoricalTable.jsx";
import HistoricalPagination from "./HistoricalPagination";

class HistoricalUnitPricesTable extends React.Component {
  state = {
    currentPage: 1,
    pageSize: 10,
  };

  componentDidUpdate(prevProps) {
    const { refreshPagination, setRefreshPagination } = this.props;

    if (refreshPagination && !prevProps.refreshPagination) {
      this.setState({ currentPage: 1 });
      setRefreshPagination(false);
    }
  }

  getTableData = () => {
    const { historicalData } = this.props;

    return (historicalData?.fundValues || []).map((item, index) => ({
      id: index + 1,
      date: item.exitDate,
      entryPrice: item.entry,
      exitPrice: item.exit,
    }));
  };

  getTotalPages = (totalItems) => {
    const { pageSize } = this.state;
    return Math.max(1, Math.ceil(totalItems / pageSize));
  };

  getCurrentRows = (tableData) => {
    const { currentPage, pageSize } = this.state;
    const startIndex = (currentPage - 1) * pageSize;

    return tableData.slice(startIndex, startIndex + pageSize);
  };

  goToPage = (page, totalPages) => {
    if (page < 1 || page > totalPages) {
      return;
    }

    this.setState({ currentPage: page });
  };

  handlePageSizeChange = (event) => {
    this.setState({
      pageSize: Number(event.target.value),
      currentPage: 1,
    });
  };

  render() {
    const { historicalData } = this.props;
    const { currentPage, pageSize } = this.state;

    const tableData = this.getTableData();
    const currentRows = this.getCurrentRows(tableData);
    const totalPages = this.getTotalPages(tableData.length);
    const fundName = historicalData?.fundName || "";

    return (
      <div className="historical-table-width">
        <h3 className="header3-historical">{fundName}</h3>

        <HistoricalTable rows={currentRows} />

        <HistoricalPagination
          currentPage={currentPage}
          pageSize={pageSize}
          totalPages={totalPages}
          onPageChange={this.goToPage}
          onPageSizeChange={this.handlePageSizeChange}
        />
      </div>
    );
  }
}

export default HistoricalUnitPricesTable;